import { Model } from '@vuex-orm/core'

export default class QuestionnaireInvite extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'questionnaireInvites'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      status: this.attr(null),
      placement_id: this.attr(null),
      candidate_id: this.attr(null),
      questionform_id: this.attr(null),
      email: this.attr(null),
      token: this.attr(null),
      url: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/QuestionnaireInvite.js